import { Link } from '@flos/react-ui';
import { useState } from 'react';
import ViewInformationModal from '../ViewInformationModal/ViewInformationModal';

const CustomerBenefitText = ({
    interactive,
    title,
    description,
    shouldRenderShoppingBasketDesign = false
}: {
    interactive?: boolean;
    title: string;
    description: string;
    shouldRenderShoppingBasketDesign?: boolean;
}): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            {interactive ? (
                <>
                    <Link
                        className={
                            !shouldRenderShoppingBasketDesign
                                ? 'paragraph--small u-spacing-stack-none'
                                : undefined
                        }
                        theme={'logo'}
                        onClick={() => {
                            setShowModal(true);
                        }}
                    >
                        {title}
                    </Link>
                    {showModal && (
                        <ViewInformationModal
                            closeModal={() => {
                                setShowModal(false);
                            }}
                            showModal={showModal}
                            modalProps={{
                                title,
                                description
                            }}
                        />
                    )}
                </>
            ) : (
                <p className="paragraph--small u-spacing-stack-xs u-color-primary-1-base">
                    {title}
                </p>
            )}
        </div>
    );
};

export default CustomerBenefitText;
